export const API = `${process.env.REACT_APP_BACKEND_URL}/api/operations`;

export const errorMessage = (requestError, fallback) => {
  const detail = requestError.response?.data?.detail;
  if (Array.isArray(detail)) {
    return detail.map((item) => item?.msg).filter(Boolean).join("; ") || fallback;
  }
  if (typeof detail === "string") return detail;
  if (detail && typeof detail === "object" && typeof detail.message === "string") {
    return detail.message;
  }
  return fallback;
};

export const money = (value) =>
  `$${Number(value || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const TERM_DAYS = { "2_weeks": 14, "3_weeks": 21 };

export const addDays = (isoDate, days) => {
  if (!isoDate) return "";
  const parsed = new Date(`${isoDate}T00:00:00`);
  if (Number.isNaN(parsed.getTime())) return "";
  parsed.setDate(parsed.getDate() + days);
  return parsed.toISOString().slice(0, 10);
};

export const todayIso = () => new Date().toISOString().slice(0, 10);

export const isOverdue = (item) =>
  item.type === "contractor" && item.status === "unpaid" && item.due_date && item.due_date < todayIso();

export const DUE_SOON_DAYS = 2;

export const isDueSoon = (item) =>
  item.type === "contractor" &&
  item.status === "unpaid" &&
  item.due_date &&
  item.due_date >= todayIso() &&
  item.due_date <= addDays(todayIso(), DUE_SOON_DAYS);

export const exportPaymentsCsv = (profile, payments) => {
  const isContractor = profile.type === "contractor";
  const headers = isContractor
    ? ["Amount", "Status", "Submitted", "Due", "Paid", "Notes"]
    : ["Amount", "Status", "Payment date", "Rate used", "Hours", "Days", "Notes"];
  const cell = (value) => `"${String(value ?? "").replace(/"/g, '""')}"`;
  const rows = payments.map((item) =>
    (isContractor
      ? [item.amount, item.status, item.submitted_date, item.due_date, item.paid_date, item.notes]
      : [item.amount, item.status, item.payment_date, item.rate_used, item.hours, item.days, item.notes]
    ).map(cell).join(","),
  );
  const csv = [headers.map(cell).join(","), ...rows].join("\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `payroll_${profile.name.replace(/\s+/g, "_")}_history.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

export const exportCompanySummaryCsv = ({ rows, totals }) => {
  const cell = (value) => `"${String(value ?? "").replace(/"/g, '""')}"`;
  const typeLabel = (type) => (type === "in_house" ? "In-House" : "Contractor");
  const headers = [
    "Type",
    "Name",
    "Status",
    "Paid to date",
    "Outstanding",
    "Overdue count",
    "Overdue amount",
    "Last payment",
  ];
  const bodyRows = rows.map((row) =>
    [
      typeLabel(row.type),
      row.name,
      row.active ? "Active" : "Inactive",
      row.paid_total,
      row.outstanding_total,
      row.overdue_count,
      row.overdue_total,
      row.last_payment_date,
    ].map(cell).join(","),
  );
  const totalsRow = [
    "TOTALS",
    `${totals.profile_count} profiles`,
    "",
    totals.paid_total,
    totals.outstanding_total,
    totals.overdue_count,
    totals.overdue_total,
    "",
  ].map(cell).join(",");
  const csv = [headers.map(cell).join(","), ...bodyRows, "", totalsRow].join("\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `payroll_company_summary_${todayIso()}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

export const blankProfile = (type) =>
  type === "in_house"
    ? { type, name: "", address: "", tax_info: "", notes: "", default_rate: 0, active: true }
    : { type, name: "", address: "", tax_info: "", notes: "", payment_term: "2_weeks", active: true };

export const blankPayment = (type) =>
  type === "in_house"
    ? { amount: 0, status: "unpaid", notes: "", payment_date: "", rate_used: "", hours: "", days: "" }
    : { amount: 0, status: "unpaid", notes: "", submitted_date: "", due_date: "", paid_date: "", job: "" };
